import type { RegionDomain } from '~/@entities/Region/domain'
import type { GradeHigh, GradeMiddle, Semester } from '~/@entities/SchoolSystem/schema'

import type { SchoolTestApi } from './api'

export namespace SchoolTestDomain {
  export const SCHOOL_TEST_TYPES = ['MIDTERM', 'FINAL'] as const
  export type SchoolTestType = (typeof SCHOOL_TEST_TYPES)[number]
  export const SCHOOL_TEST_TERM_KOR: Record<SchoolTestType, string> = {
    MIDTERM: '중간',
    FINAL: '기말',
  }

  export type ProvideType = 'ALL' | 'PDF_ONLY' | 'SIMILAR_ONLY' | 'NONE'
  export type UploaderType = 'MATHFLAT' | 'CUSTOMER'

  export const SCHOOL_TEST_CORNER_TYPES = [
    'SCHOOL_TEST__CONCEPT',
    'SCHOOL_TEST__PAIR_SIMILAR',
    'SCHOOL_TEST__SCHOOL_WORKBOOK',
    'SCHOOL_TEST__PRACTICE_TEST',
  ] as const
  // SCHOOL_TEST__CONCEPT: 개념 추가
  // SCHOOL_TEST__PAIR_SIMILAR: 기출 유형, (반드시 필요)
  // SCHOOL_TEST__SCHOOL_WORKBOOK: 교과서 문제
  // SCHOOL_TEST__PRACTICE_TEST: 실전 모의고사

  export type SchoolTestCornerType = (typeof SCHOOL_TEST_CORNER_TYPES)[number]

  /**
   * 기출 시험지 원본 데이터
   * - 특이사항: workbook으로 취급하고 있음
   */
  export class SchoolTestOrigin {
    id: number
    title: string
    year: number
    grade: GradeMiddle | GradeHigh
    semester: Semester
    enforcementGrade: number | null
    enforcementSemester: Semester | null
    schoolTestType: SchoolTestType
    uploaderType: UploaderType
    provideType: ProvideType
    subTitle: string
    maxPage: number
    createDatetime: Date
    startCurriculumSequenceOfExamScope: null
    endCurriculumSequenceOfExamScope: null
    region: RegionDomain.Region & { priority: number | null }
    school: RegionDomain.SchoolByRegion
    pdfDownloaded: boolean

    constructor(
      data: Omit<SchoolTestApi.Response.SchoolTestOrigin, 'createDatetime'> & {
        createDatetime: string
      },
    ) {
      this.id = data.id
      this.title = data.title
      this.year = data.year
      this.grade = data.grade
      this.semester = data.semester
      this.enforcementGrade = data.enforcementGrade
      this.enforcementSemester = data.enforcementSemester
      this.schoolTestType = data.schoolTestType
      this.uploaderType = data.uploaderType
      this.provideType = data.provideType
      this.subTitle = data.subTitle
      this.maxPage = data.maxPage
      this.createDatetime = new Date(data.createDatetime)
      this.startCurriculumSequenceOfExamScope = data.startCurriculumSequenceOfExamScope
      this.endCurriculumSequenceOfExamScope = data.endCurriculumSequenceOfExamScope
      this.region = data.region
      this.school = data.school
      this.pdfDownloaded = data.pdfDownloaded
    }
  }
}
